import React, { Component } from 'react';

import { FormEdit } from 'Components/FormEdit';
import Datetime, { formatUtc } from 'Components/inputs/Datetime';
import TextInput from 'Components/inputs/Text';
import Toggle, { normalizeBoolean } from 'Components/inputs/Toggle';
import ImageInput from '../../images/Input';

export default class Form extends Component {
  config = {
    fields: [
      'id',
      'name',
      'competitionName',
      'competitionShortName',
      'slug',
      'isOverSingleYear',
      'isActive',
      'hasRankings',
      'isMultiGroupChampionship',
      'hasMatches',
      'nextDrawDate',
    ],
    // image is a related resource: declared here so getInitialValues extracts its @id (IRI string)
    // for ImageInput, instead of keeping the embedded object (which getLinkId can't split). Cf. V2-2069.
    objectFields: ['image'],
    disposition: [
      {
        // Per-season logo (V2-2069): editable like the competition logo.
        size: 3,
        fields: [{ name: 'image', component: ImageInput }],
      },
      {
        size: 6,
        fields: [
          { name: 'name', component: TextInput },
          // Per-season historical competition name (V2-2069): editable so editors can correct
          // the name a division carried during this season after an Opta cascade rename.
          { name: 'competitionName', component: TextInput },
          // Short form of that historical name (V2-2069), which page headers prefer. Left empty, the
          // season inherits the competition's current short name, and the site then displays the
          // historical long name above when the competition has no short name at all.
          { name: 'competitionShortName', component: TextInput },
          { name: 'slug', component: TextInput, disabled: true },
        ],
      },
      {
        size: 9,
        fields: [{ name: 'nextDrawDate', component: Datetime, normalize: formatUtc, size: 6 }],
      },
      {
        fields: [
          {
            name: 'isActive',
            component: Toggle,
            normalize: normalizeBoolean,
            size: 6,
          },
          {
            name: 'isOverSingleYear',
            component: Toggle,
            normalize: normalizeBoolean,
            size: 6,
          },
          {
            name: 'hasRankings',
            component: Toggle,
            normalize: normalizeBoolean,
            size: 6,
          },
          {
            name: 'isMultiGroupChampionship',
            component: Toggle,
            normalize: normalizeBoolean,
            size: 6,
          },
          {
            name: 'hasMatches',
            component: Toggle,
            normalize: normalizeBoolean,
            size: 6,
          },
        ],
      },
    ],
  };

  render() {
    const { data, onSubmit } = this.props;

    return (
      <FormEdit
        key={data.id}
        form={`tournament_${data.id}`}
        onSubmit={onSubmit}
        data={data}
        config={this.config}
        main
        useUserRestriction
      />
    );
  }
}
